import { RequestTableFiltersActionTypes, RequestTableFiltersState, SET_REQUEST_TABLE_FILTERS } from "store/reducers/lodgingRequest/requestTableFilters/types";

const defaultState: RequestTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: {},
  exists: false,
};

export default function requestTableFilters(state = defaultState, action: RequestTableFiltersActionTypes): RequestTableFiltersState {
  switch (action.type) {
    case SET_REQUEST_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
